<template>
  <div>
    <!--  -->
    <div>
      <table class="table" style="margin: 0;">
        <tbody>
          <th>
            <td>
              <div class="dropdown">
                <button
                  class="btn btn-primary dropdown-toggle"
                  type="button"
                  data-toggle="dropdown"
                  style="height: fit-content;"
                >
                  {{ $t(btnDropDownTitle) }} <span class="caret"></span>
                </button>
                <div
                  id="dropdown"
                  class="dropdown-menu apartment-group-filter-component"
                  style="padding: 10px; min-width: 250px;"
                >
                  <div class="row">
                    <div class="col-md-6">
                      <input
                        id="selectAllApartmentGroup"
                        type="checkbox"
                        v-model="selectAllApartmentGroup"
                        @change="onChangeSelectAllApartmentGroup"
                      />
                    </div>
                    <div class="col-md-6">
                      <span
                        class="management-group-class pull-right"
                        style="color: red"
                        @click="uncheckSelectAllApartmentGroup"
                        ><small>{{ $t("common.uncheckAll") }}</small></span
                      >
                    </div>
                  </div>
                  <hr style="margin: 7.5px 0">
                  <div v-if="isFilter" class="apartment-group-class">
                    <div>
                      <div
                        v-for="(item, index) in apartmentGroupListFilter"
                        :key="item + index"
                      >
                        <input
                          :id="item + index"
                          type="checkbox"
                          v-model="item.select"
                        />
                        <label class="control-label" :for="item + index">{{
                          item.text
                        }}</label>
                      </div>
                    </div>
                  </div>
                  <div v-else class="apartment-group-class">
                    <div>
                      <div
                        v-for="(item, index) in apartmentGroupListAdd"
                        :key="item + index"
                      >
                        <input
                          :id="item + index"
                          type="checkbox"
                          v-model="item.select"
                        />
                        <label class="control-label" :for="item + index">{{
                          item.text
                        }}</label>
                      </div>
                    </div>
                  </div>
                  <div v-if="isFilter" class="row" style="padding-top: 15px;">
                    <div class="col-md-6">
                      <span
                        v-if="
                          checkEnableModuleOrExtraInfo(true, keyCheckModuleManagementApartmentGroup) &&
                            !isHideManagementApartmentGroup
                        "
                        class="management-group-class"
                        @click="goToManagementGroup"
                        ><small>{{ $t("apartment.managementApartmentGroup") }}</small></span
                      >
                    </div>
                    <div class="col-md-6">
                      <div class="group-form">
                        <button
                          type="button"
                          class="btn btn-labeled btn-primary btn-sm pull-right"
                          data-toggle="dropdown"
                          @click="onConfirm"
                        >
                          {{ $t("common.confirm") }}
                        </button>
                      </div>
                    </div>
                  </div>
                  <div v-else class="row" style="padding-top: 15px;">
                    <div class="col-md-12">
                      <button
                        type="button"
                        class="btn btn-labeled btn-danger btn-sm pull-left"
                        @click="showModalConfirm(2)"
                      >
                        {{ $t("common.delete") }}
                      </button>
                      <button
                        type="button"
                        class="btn btn-labeled btn-primary btn-sm pull-right"
                        @click="showModalConfirm(1)"
                      >
                        {{ $t("apartment.addApartmentInGroup") }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </td>
            <td>
              <div v-if="isFilter">
                <div v-if="!isHideNumberApartment" style="white-space: nowrap; padding: 5px">
                  {{
                    $t("apartment.numberApartmentInGroup", {
                      number:
                        apartmentGroupIdFilter.length > 0 ? numberApartmentInGroup : 0
                    })
                  }}
                </div>
              </div>
            </td>
            <td v-if="isFilter" style="width: 100%;">
              <vue-input-tag
                validate="text"
                v-model="apartmentGroupName"
                style="min-height: 40px;"
                read-only
              ></vue-input-tag>
            </td>
          </th>
        </tbody>
      </table>
    </div>
    <!--  -->
    <lte-modal
      v-show="isShowModal"
      @onConfirm="onConfirmModal"
      @close="closeModal"
      v-for="obj in objModal"
      :key="obj.id"
      :item="obj"
    ></lte-modal>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import InputTag from "vue-input-tag";
import LTEModal from "@/components/LTEModal.vue";
import utils from "@/lib/utils";
export default {
  components: {
    "vue-input-tag": InputTag,
    "lte-modal": LTEModal
  },
  props: {
    isFilter: {
      type: Boolean,
      default: () => {
        return true;
      }
    },
    btnDropDownTitle: {
      type: String,
      default: () => {
        return "";
      }
    },
    numberApartmentInGroup: {
      type: Number,
      default: () => {
        return 0;
      }
    },
    isHideNumberApartment: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    isHideManagementApartmentGroup: {
      type: Boolean,
      default: () => {
        return false
      }
    }
  },
  data: () => ({
    apartmentGroupListFilter: [],
    apartmentGroupIdFilter: [],
    apartmentGroupListAdd: [],
    apartmentGroupIdAdd: [],
    apartmentGroupName: [],
    isShowModal: false,
    objModal: [
      {
        title: "common.delete_modal.notiTitle",
        body: "common.delete_modal.content",
        buttonNo: "common.delete_modal.btnNo",
        buttonYes: "common.delete_modal.btnYes",
        styleType: "default"
      }
    ],
    isConfirmType: 1,
    keyCheckModuleManagementApartmentGroup: "apartment_group",
    selectAllApartmentGroup: false
  }),
  watch: {
    // isFilter: function() {
    //   this.$emit("emitFilterApartmentInGroup", this.apartmentGroupIdFilter);
    // }
  },
  computed: {
    ...mapGetters([
      "GET_ENABLE_MODULE_AND_EXTRA_INFO_DATA"
    ])
  },
  methods: {
    checkEnableModuleOrExtraInfo: function(isModule, key) {
      return utils.checkEnableModuleOrExtraInfo(this.GET_ENABLE_MODULE_AND_EXTRA_INFO_DATA, isModule, key)
    },
    showError: function(msg) {
      this.ON_SHOW_TOAST({
        message: this.$t(msg),
        styleType: "danger"
      });
    },
    getApartmentGroupList: function() {
      this.apartmentGroupListFilter = [];
      this.apartmentGroupListAdd = [];
      this.GET_APARTMENT_GROUP_LIST().then(
        function(res) {
          let data = res;
          data.forEach(value => {
            let apartmentFilter = {
              value: value.id,
              text: value.name,
              select: false
            };
            this.apartmentGroupListFilter.push(apartmentFilter);
            //
            let apartmentAdd = {
              value: value.id,
              text: value.name,
              select: false
            };
            this.apartmentGroupListAdd.push(apartmentAdd);
          });
        }.bind(this)
      )
      .catch(
        function() {
          this.isLoading = false;
        }.bind(this)
      );
    },
    onConfirm: function() {
      let resultList = [];
      let apartmentGroupName = [];
      if (this.isFilter) {
        for (let i = 0; i < this.apartmentGroupListFilter.length; i++) {
          if (this.apartmentGroupListFilter[i].select) {
            resultList.push(this.apartmentGroupListFilter[i].value);
            apartmentGroupName.push(this.apartmentGroupListFilter[i].text);
          }
        }
        this.apartmentGroupIdFilter = resultList;
        this.apartmentGroupName = apartmentGroupName;
        this.$emit("emitFilterApartmentInGroup", this.apartmentGroupIdFilter);
      }
    },
    showModalConfirm: function(value) {
      this.isConfirmType = value;
      this.onAddApartmentInGroup();
      if (this.apartmentGroupIdAdd.length === 0) {
        this.showError("apartment.notiSelectApartmentGroup");
      } else {
        if (value === 1) {
          this.objModal[0].body = "apartment.notiAddApartmentListInGroup";
          this.isShowModal = true;
        }
        if (value === 2) {
          this.objModal[0].body = "apartment.notiDeleteApartmentListInGroup";
          this.isShowModal = true;
        }
      }
    },
    onAddApartmentInGroup: function() {
      let resultList = [];
      for (let i = 0; i < this.apartmentGroupListAdd.length; i++) {
        if (this.apartmentGroupListAdd[i].select) {
          resultList.push(this.apartmentGroupListAdd[i].value);
        }
      }
      this.apartmentGroupIdAdd = resultList;
    },
    closeModal: function() {
      this.isShowModal = false;
    },
    onConfirmModal: function() {
      if (this.isConfirmType === 1) {
        this.$emit("emitAddApartmentInGroup", this.apartmentGroupIdAdd);
        this.closeModal();
      }
      if (this.isConfirmType === 2) {
        this.$emit("emitDeleteApartmentInGroup", this.apartmentGroupIdAdd);
        this.closeModal();
      }
    },
    goToManagementGroup: function() {
      this.$router.push({
        name: "ApartmentGroupList"
      });
    },
    onChangeSelectAllApartmentGroup: function() {
      if (this.isFilter) {
        // this.apartmentGroupListFilter = this.apartmentGroupListFilter.filter(
        //   x=> {
        //     x.select = this.selectAllApartmentGroup
        //     return x.select
        //   }
        // )
        this.apartmentGroupListFilter.filter(
          x=> {
            x.select = this.selectAllApartmentGroup
            return x.select
          }
        )
      } else {
        this.apartmentGroupListAdd.filter(
          x=> {
            x.select = this.selectAllApartmentGroup
            return x.select
          }
        )
      }
    },
    uncheckSelectAllApartmentGroup: function() {
      this.selectAllApartmentGroup = false
      this.onChangeSelectAllApartmentGroup()
    },
    ...mapActions([
      "ON_SHOW_TOAST",
      "GET_APARTMENT_GROUP_LIST"
    ])
  },
  mounted() {
    $(".apartment-group-filter-component").on("click", function(e) {
      e.stopPropagation();
    });

    this.getApartmentGroupList();
  }
};
</script>
<style scoped>
.apartment-group-class {
  max-height: 250px;
  overflow: auto;
}
.management-group-class {
  white-space: nowrap;
  color: blue;
}
.management-group-class:hover {
  text-decoration: underline;
  color: blue;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/Apartment/ApartmentGroupFilterComponent.vue